export default __webpack_public_path__ + "images/filtered.png?16b69c37486d4a1dc65a73ae2bf0ab12";